import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsStacked01 = function CoinsStacked01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 17c0 2.7614 2.2386 5 5 5s5-2.2386 5-5-2.2386-5-5-5-5 2.2386-5 5m0 0a4.978 4.978 0 0 1 1-3.0005V5m-1 12c0 .8254.2 1.604.5541 2.2901C11.7117 20.0018 9.7658 20.5 7.5 20.5c-3.0376 0-5.5-.8954-5.5-2V5m11 0c0 1.1046-2.4624 2-5.5 2S2 6.1046 2 5m11 0c0-1.1046-2.4624-2-5.5-2S2 3.8954 2 5m0 9c0 1.1046 2.4624 2 5.5 2 2.189 0 4.0793-.465 4.9646-1.1382M13 9.5c0 1.1046-2.4624 2-5.5 2S2 10.6046 2 9.5"
    })
  }));
};
export default CoinsStacked01;